// Domain
import { ForgotPasswordRepository } from '../../../domain/repositories';
import injectable from '@/modules/shared/domain/di/injectable';

@injectable()
export default class ForgotPasswordDummyRepository implements ForgotPasswordRepository {
  // eslint-disable-next-line class-methods-use-this
  restore(): Promise<void> {
    return Promise.resolve();
  }
}
